import React from "react";
import BreadCrumb from "../../Common/BreadCrumb";

const Switches = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Switches" pageType="Forms" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Switches Solid
            </h2>
            <div className="inline-block togglebutton">
              <label
                htmlFor="toggleD1"
                className="flex items-center cursor-pointer"
              >
                <div className="relative">
                  <input type="checkbox" id="toggleD1" className="sr-only" />
                  <div className="block band bg-black/10 w-[54px] h-[29px] dark:bg-darkmuted/50"></div>
                  <div className="dot absolute left-[3px] top-[2px] bg-white w-6 h-6 transition dark:bg-dark"></div>
                </div>
              </label>
            </div>
          </div>
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Switches Solid Rounded
            </h2>
            <div className="inline-block togglebutton">
              <label
                htmlFor="toggleD2"
                className="flex items-center cursor-pointer"
              >
                <div className="relative">
                  <input type="checkbox" id="toggleD2" className="sr-only" />
                  <div className="block band bg-black/10 w-[54px] h-[29px] rounded-full dark:bg-darkmuted/50"></div>
                  <div className="dot absolute left-[3px] top-[2px] bg-white w-6 h-6 rounded-full transition dark:bg-dark"></div>
                </div>
              </label>
            </div>
          </div>
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Switches Outline
            </h2>
            <div className="inline-block togglebutton out-line">
              <label
                htmlFor="toggleD3"
                className="flex items-center cursor-pointer"
              >
                <div className="relative">
                  <input type="checkbox" id="toggleD3" className="sr-only" />
                  <div className="block band border border-black/10 w-[52px] h-[29px] dark:bg-darkmuted/50"></div>
                  <div className="dot absolute left-1 top-[3.5px] bg-black/50 w-[22PX] h-[22PX] transition dark:bg-dark"></div>
                </div>
              </label>
            </div>
          </div>
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Switches Outline Rounded
            </h2>
            <div className="inline-block togglebutton out-line">
              <label
                htmlFor="toggleD4"
                className="flex items-center cursor-pointer"
              >
                <div className="relative">
                  <input type="checkbox" id="toggleD4" className="sr-only" />
                  <div className="block band border border-black/10 w-[54px] h-[29px] rounded-full dark:bg-darkmuted/50"></div>
                  <div className="dot absolute left-[5px] top-[3.5px] bg-black/50 w-[22PX] h-[22PX] rounded-full transition dark:bg-dark"></div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Switches;
